/* unplugin-vue-components disabled */import { render } from "./OpticalPathQuestionConfigurator.vue?vue&type=template&id=0a056704&scoped=true"
import script from "./OpticalPathQuestionConfigurator.vue?vue&type=script&lang=js"
export * from "./OpticalPathQuestionConfigurator.vue?vue&type=script&lang=js"

import "./OpticalPathQuestionConfigurator.vue?vue&type=style&index=0&id=0a056704&lang=scss&scoped=true"
import "./OpticalPathQuestionConfigurator.vue?vue&type=style&index=1&id=0a056704&lang=scss"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a056704"]])

export default __exports__